export const modalButtonOrientation = {
  HORIZONTAL: 'modalButtonOrientation.HORIZONTAL',
  VERTICAL: 'modalButtonOrientation.VERTICAL',
};
